import React from "react";

import { bem } from "@react-md/utils";
import AntdSkeleton, { SkeletonProps as AntdSkeletonProps } from "antd/es/skeleton";
import cn from "classnames";

const block = bem("mmc-skeleton");

export interface SkeletonProps extends AntdSkeletonProps {}

const Skeleton = ({ className, ...props }: SkeletonProps) => {
  return <AntdSkeleton className={cn(block(), className)} {...props} />;
};

export default Skeleton;
